// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__2d8eT","load6":"Spinner_load6__2DN2I","round":"Spinner_round__um3fI"};